export default __webpack_public_path__ + "static/media/AKM_6.a21ded05.png";